import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { useWorkspaceContext } from 'hooks/common';
import { SinglePluginAuthenticationResponse } from 'types/PluginAuthentications';
import { NULL_CACHE_AND_STALE_TIME } from 'constants/index';
import { openAuthScreen } from 'utilities/index';

type mutationVariables = {
  pluginAuthenticationID: string | undefined;
  description?: string;
  name?: string;
};
type Props = {
  authenticationConnection: mutationVariables;
  enabled: boolean;
};

export function useAutoPluginAuthenticationAuthorizeConnection({
  authenticationConnection,
  enabled,
}: Props) {
  const { currentWorkspaceID } = useWorkspaceContext();

  const pluginAuthenticationAuthorizeConnection = () => {
    const { pluginAuthenticationID, name, description } =
      authenticationConnection;

    const body = {
      data: {
        id: pluginAuthenticationID,
        type: 'pluginAuthentications',
        attributes: {
          workspaceID: currentWorkspaceID,
          name,
          description,
        },
      },
    };

    return fetchWrapper<SinglePluginAuthenticationResponse>({
      url: SPARK_RESOURCE_TYPES.PLUGIN_AUTHENTICATIONS_AUTHORIZE_CONNECTION,
      method: 'POST',
      body: body,
    });
  };

  const response = useQuery(
    [
      'AutoPluginAuthenticationAuthorizeConnection',
      authenticationConnection.pluginAuthenticationID,
    ],
    pluginAuthenticationAuthorizeConnection,
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(
            `failed to Authorize Plugin Connection: ${error.message}`
          );
        }
      },
      onSuccess: (data) => {
        const { redirect, redirectURL } = data.data.meta;
        if (redirect && redirectURL) {
          openAuthScreen(redirectURL);
        }
      },

      enabled: enabled,
      ...NULL_CACHE_AND_STALE_TIME,
    }
  );
  return response;
}
